<template>
  <div :class="['date-form__input field', { 'date-form__input--focused': isFocused }, `date-form__input--length-${maxLength}`]">
    <label class="label">
      {{ label }}
    </label>
    <div class="control">
      <input
        ref="input"
        :type="type"
        :class="[
          'date-form__input-field input is-large',
          { 'date-form__input-field--invalid': validator.$error },
          { 'date-form__input-field--valid': !validator.$invalid },
        ]"
        :maxlength="maxLength"
        :name="name"
        :placeholder="placeholder"
        autocomplete="off"
        @input="inputHandler"
        @focus="focusHandler"
        @blur="blurHandler"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateFormInput',
  props: {
    autoFocus: { type: Boolean, default: false },
    label: { type: String, required: true },
    maxLength: { type: Number, default: 0 },
    name: { type: String, required: true },
    placeholder: { type: String, required: true },
    type: { type: String, default: 'tel' },
    value: { type: String, required: true },
    validator: { type: Object, required: true },
  },
  data() {
    return {
      focusedInput: 'day',
      day: [],
      isFocused: false,
    }
  },
  mounted() {
    const fieldUrlParam = this.$URLParamsHelper.getParam(this.name)

    if (fieldUrlParam) {
      this.$refs.input.value = fieldUrlParam
      this.$emit('input', fieldUrlParam)
    }

    if (this.autoFocus) {
      this.focusHandler()
    }

    if (!this.maxLength) {
      this.$refs.input.removeAttribute('maxlength')
    }

    if (this.type === 'flatpickr') {
      this.$refs.input.setAttribute('step', 60)
      this.$refs.input.setAttribute('type', 'text')

      import('flatpickr').then(({ default: flatpickr }) => {
        flatpickr(this.$refs.input, {
          dateFormat: 'H:i',
          defaultHour: 0,
          defaultMinute: 0,
          enableTime: true,
          noCalendar: true,
          time_24hr: true,
          onOpen: () => { this.isFocused = true },
          onClose: () => { this.isFocused = false },
        })
      })
    }
  },
  methods: {
    focusHandler() {
      if (this.type === 'flatpickr') return

      this.isFocused = true
      this.$refs.input.select()
    },
    blurHandler() {
      if (this.type === 'flatpickr') return

      this.isFocused = false
    },
    inputHandler({ currentTarget }) {
      this.validator.$touch()

      this.$emit('input', currentTarget.value)

      if (this.maxLength && currentTarget.value.length === this.maxLength) {
        this.$emit('inputFilled')
      }
    },
  },
}
</script>
